import * as React from 'react';
export const IcTableTennis = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M19 17a2 2 0 100 4 2 2 0 000-4zM6.22 14l-2.63 2.59a2 2 0 102.82 2.82l2.94-2.93A7.07 7.07 0 0012 17c.46 0 .92-.047 1.37-.14L5 10.25A7 7 0 006.22 14zM12 3a7 7 0 00-6.69 4.93L15.54 16A7 7 0 0012 3z'
      fill='currentColor'
    />
  </svg>
);
